// Sparkline — compact trend line from a numeric series. Pure SVG, no axes.
// Optional area fill and end dot. Used in balance/holding trend previews.
import PropTypes from 'prop-types';

export function Sparkline({
  data,
  color = 'var(--brand-blue)',
  width = 80,
  height = 24,
  strokeWidth = 1.6,
  fill = false,
  preserveAspectRatio,
  className,
}) {
  if (!data || data.length < 2) return <svg width={width} height={height} className={className} />;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const span = max - min || 1;
  const stepX = width / (data.length - 1);
  const pts = data.map((v, i) => [i * stepX, height - ((v - min) / span) * (height - strokeWidth * 2) - strokeWidth]);
  const line = pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join(' ');
  const area = `${line} L ${width} ${height} L 0 ${height} Z`;
  const gid = `spark-${Math.round(width)}-${Math.round(height)}-${data.length}`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={preserveAspectRatio} className={className} aria-hidden="true">
      {fill && (
        <>
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.22" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={area} fill={`url(#${gid})`} />
        </>
      )}
      <path d={line} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Sparkline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  strokeWidth: PropTypes.number,
  fill: PropTypes.bool,
  /** SVG preserveAspectRatio; pass "none" to stretch the chart to fill its box. */
  preserveAspectRatio: PropTypes.string,
  className: PropTypes.string,
};

export default Sparkline;
